import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { BookCover } from './BookCover';
import { CtaButton } from './CtaButton';
import { RichText } from './RichText';
import { volumes } from '../../data/landing';
export function Volumes() {
  return <section id="tomos" aria-labelledby="volumes-title" className="scroll-mt-16 bg-paper py-16 md:py-24" data-id="element-246" data-mp="ec9ynd2qhbht">
      <div className="mx-auto max-w-6xl px-5" data-id="element-247" data-mp="l4v3zw8vz27">
        <SectionHeading id="volumes-title" title={<>
              6 tomos, <em className="text-primary" data-id="element-249" data-mp="5e7refsepmm3">un objetivo cada uno</em>
            </>} subtitle="Buscás por lo que querés trabajar, elegís el recurso y lo usás. Cada tomo reúne material para un objetivo terapéutico." data-id="element-248" data-mp="jbnoidt5at5" />

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-250" data-mp="3drers6ls7a9b">
          {volumes.map(v => <li key={v.number} className="flex flex-col overflow-hidden rounded-3xl border border-line bg-cream" data-id="element-251" data-mp="3irau81etytmr">
              <div className="flex justify-center px-8 pb-6 pt-8" style={{
            backgroundColor: `${v.color}66`
          }} data-id="element-252" data-mp="2masetajxi0bk">
                <BookCover eyebrow={`Tomo ${v.number}`} title={v.title} color={v.color} deep={v.deep} icon={v.icon} className="w-[46%] -rotate-3" data-id="element-253" data-mp="2i9p22wx6gkek" />
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-7" data-id="element-254" data-mp="23m42hczih3be">
                <span className="text-xs font-bold uppercase tracking-[0.14em]" style={{
              color: v.deep
            }} data-id="element-255" data-mp="1ymrf8r4q9u8a">
                  Tomo {v.number}
                </span>
                <h3 className="mt-1.5 font-serif text-[1.7rem] leading-tight text-ink" data-id="element-256" data-mp="2dd8goahd4k56">{v.title}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-257" data-mp="28icbs9r122an">{v.description}</p>
                <ul className="mt-5 space-y-2.5 border-t border-line pt-5" data-id="element-258" data-mp="1ksrr9mf86wz9">
                  {v.includes.map((item, i) => <li key={i} className="flex items-start gap-2.5 text-[15px] text-ink" data-id="element-259" data-mp="3fy982r1fp22a" data-mpi={i}>
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" data-id="element-260" data-mp="3kx3zuihdq0yj" />
                      <span data-id="element-261" data-mp="3pnsv88w6ji2y">
                        <RichText text={item} data-id="element-262" data-mp="3pnkh6dobm6q6" />
                      </span>
                    </li>)}
                </ul>
                <div className="mt-auto flex gap-2 pt-6" data-id="element-263" data-mp="3trieciu357gl">
                  {['Imprimible', 'Digital'].map(tag => <span key={tag} className="rounded-full bg-paper px-3 py-1 text-xs font-semibold text-muted ring-1 ring-line" data-id="element-264" data-mp="31y88rg0ti2ox">
                      {tag}
                    </span>)}
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 flex justify-center" data-id="element-265" data-mp="3awjv35uniebk">
          <CtaButton data-id="element-266" data-mp="l8kn0nrsa1zw">Quiero los 6 tomos</CtaButton>
        </div>
      </div>
    </section>;
}